<template lang="jade">
    div.Panels
      div.Panel(
        v-for="panel in panels"
        @click="selected(panel.value)"
        v-bind:class="{'Panel__active': panel.value === formInput}"
      )
        div.Panel__header
          div.Panel__title {{ panel.label }}
        div.Panel__body {{ panel.tip }}
</template>

<script>
import _ from 'lodash'
import { addNotification, removeNotification } from 'src/vuex/actions'
import { skins } from 'src/vuex/getters'

export default {
  data () {
    return {uid: this.$parent.uid,
            formInput: '',
            attempts: 0}
  },
  props: {
    fdata: {
      type: Object,
      coerce (val) {
        let input = _.head(val.content)
        return Object.assign({}, val, {
          validation: input.validation || [],
          field: input.field
        })
      },
      required: true
    }
  },

  vuex: {
    getters: {skins},
    actions: {addNotification,
              removeNotification}
  },

  computed: {
    panels () {
      return _.head(this.fdata.content).options
    }
  },

  watch: {
    'formInput': 'validate'
  },

  methods: {
    selected (val) {
      this.$set('formInput', val)
      this.$set('attempts', this.attempts++)
    },

    validate () {
      if (!this.fdata.validation) return this.dispatch()
      let validated = this.computedValidate(this.fdata, this.formInput)
      this.notice('error', validated)
    },

    notice (type, valid) {
      _.isNil(valid) || _.isEmpty(valid)
        ? this.removeNotification(this.fdata.field)
        : this.addNotification({type: type,
                                msg: valid,
                                id: this.fdata.field,
                                show: this.attempts > 0})
      this.dispatch()
    },

    dispatch () {
      if (this.fdata.field) {
        this.$dispatch('fdata::input', {
          [this.fdata.field]: this.formInput
        })
      }
    }
  },

  ready () {
    if (this.fdata.validation) this.validate()
  }
}
</script>



// WEBPACK FOOTER //
// panels.vue?09d199ec